/**
 * Converte valori API (stringa, numero o oggetti Strapi/localized) in stringa sicura per React.
 * Oggetti tipo errore API { status, name, message, details } → stringa vuota.
 */
export function toPlainText(value) {
  if (value == null) return '';
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean')
    return String(value);
  if (typeof value !== 'object') return '';

  const o = value;
  const keys = [
    'text',
    'label',
    'name',
    'title',
    'value',
    'slug',
    'tag',
    'content',
  ];
  for (let i = 0; i < keys.length; i += 1) {
    const v = o[keys[i]];
    if (typeof v === 'string' && v) return v;
  }
  if (
    typeof o.message === 'string' &&
    o.status != null &&
    Object.prototype.hasOwnProperty.call(o, 'details')
  ) {
    return '';
  }
  return '';
}
